// import React, { useEffect, useState } from "react";
// import { getStorage, ref, getDownloadURL } from "firebase/storage";

// type StoryItem = {
//     num: number;
//     text: string;
// };

// type MatchingExerciseProps = {
//     bookNum: number;
//     unitIndex: number; // 0-based
//     lessonIndex: number; // 0-based
//     story: { num: number; text: string }[];
//     accentHex?: string;
// };

// const storage = getStorage();

// // helper do budowania ścieżki w Storage
// const getImagePath = (
//     bookNum: number,
//     unitIndex: number,
//     lessonIndex: number,
//     storyNum: number
// ) => {
//     const unit = unitIndex + 1;
//     const lesson = lessonIndex + 1;
//     return `kids/book${bookNum}/img/${unit}-${lesson}-${storyNum}.png`;
// };

// const MatchingExercise: React.FC<MatchingExerciseProps> = ({
//     bookNum,
//     unitIndex,
//     lessonIndex,
//     story,
//     accentHex,
// }) => {
//     const [imageUrls, setImageUrls] = useState<Record<string, string>>({});
//     const [texts, setTexts] = useState<{ id: string; text: string }[]>([]);
//     const [selectedImage, setSelectedImage] = useState<string | null>(null);
//     const [matched, setMatched] = useState<Record<string, boolean>>({});

//     // shuffle tekstów na start
//     useEffect(() => {
//         const shuffled = [...story]
//             .map((s) => ({ id: s.num.toString(), text: s.text }))
//             .sort(() => Math.random() - 0.5);
//         setTexts(shuffled);
//     }, [story]);

//     // pobierz obrazki z Firebase
//     useEffect(() => {
//         const loadImages = async () => {
//             const urls: Record<string, string> = {};
//             for (const s of story) {
//                 try {
//                     const path = getImagePath(bookNum, unitIndex, lessonIndex, s.num);
//                     const url = await getDownloadURL(ref(storage, path));
//                     urls[s.num.toString()] = url;
//                 } catch (e) {
//                     console.warn("Brak obrazka:", s.num, e);
//                 }
//             }
//             setImageUrls(urls);
//         };
//         loadImages();
//     }, [bookNum, unitIndex, lessonIndex, story]);

//     const handleSelectText = (textId: string) => {
//         if (!selectedImage) return;
//         if (selectedImage === textId) {
//             setMatched((prev) => ({ ...prev, [textId]: true }));
//         }
//         setSelectedImage(null);
//     };

//     return (
//         <div className="p-4">
//             <h3
//                 className="text-lg font-bold mb-4 text-center"
//                 style={{ color: accentHex || "#333" }}
//             >
//                 Match the Pictures and Words
//             </h3>

//             {/* Obrazki */}
//             <div className="flex flex-wrap justify-center gap-4 mb-6">
//                 {story.map((s) => {
//                     const id = s.num.toString();
//                     const isMatched = matched[id];
//                     const isSelected = selectedImage === id;
//                     return (
//                         <button
//                             key={id}
//                             onClick={() => !isMatched && setSelectedImage(id)}
//                             className={[
//                                 "rounded-xl overflow-hidden border-2 transition",
//                                 isMatched
//                                     ? "border-green-500 opacity-80"
//                                     : isSelected
//                                         ? "border-blue-400"
//                                         : "border-transparent",
//                             ].join(" ")}
//                         >
//                             {imageUrls[id] ? (
//                                 <img
//                                     src={imageUrls[id]}
//                                     alt={s.text}
//                                     className="w-40 h-28 object-contain bg-zinc-100"
//                                 />
//                             ) : (
//                                 <div className="w-40 h-28 flex items-center justify-center bg-zinc-100 text-sm text-zinc-400">
//                                     No image
//                                 </div>
//                             )}
//                         </button>
//                     );
//                 })}
//             </div>

//             {/* Teksty */}
//             <div className="flex flex-col gap-3">
//                 {texts.map((txt) => {
//                     const isMatched = matched[txt.id];
//                     return (
//                         <button
//                             key={txt.id}
//                             onClick={() => !isMatched && handleSelectText(txt.id)}
//                             className={[
//                                 "p-3 rounded-lg text-left transition",
//                                 isMatched
//                                     ? "bg-green-500 text-white font-bold"
//                                     : "bg-zinc-100 hover:bg-zinc-200",
//                             ].join(" ")}
//                         >
//                             {txt.text}
//                         </button>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// };

// export default MatchingExercise;


import React, { useEffect, useState } from "react";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

type StoryItem = {
    num: number;
    text: string;
};

type MatchingExerciseProps = {
    bookNum: number;
    unitIndex: number; // 0-based
    lessonIndex: number; // 0-based
    story: { num: number; text: string }[];
    accentHex?: string;
};

const storage = getStorage();

// prosty cache w pamięci
const memCache: Record<string, string> = {};

// helper do budowania ścieżki w Storage
const getImagePath = (
    bookNum: number,
    unitIndex: number,
    lessonIndex: number,
    storyNum: number
) => {
    const unit = unitIndex + 1;
    const lesson = lessonIndex + 1;
    return `kids/book${bookNum}/img/${unit}-${lesson}-${storyNum}.jpg`;
};

const MatchingExercise: React.FC<MatchingExerciseProps> = ({
    bookNum,
    unitIndex,
    lessonIndex,
    story,
    accentHex,
}) => {
    const [imageUrls, setImageUrls] = useState<Record<string, string>>({});
    const [texts, setTexts] = useState<{ id: string; text: string }[]>([]);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [matched, setMatched] = useState<Record<string, boolean>>({});

    // shuffle tekstów na start
    useEffect(() => {
        const shuffled = [...story]
            .map((s) => ({ id: s.num.toString(), text: s.text }))
            .sort(() => Math.random() - 0.5);
        setTexts(shuffled);
    }, [story]);

    // pobierz obrazki z Firebase (z cache jeśli są)
    useEffect(() => {
        const loadImages = async () => {
            const urls: Record<string, string> = {};
            for (const s of story) {

                const path = getImagePath(bookNum, unitIndex, lessonIndex, s.num);

                // sprawdzamy cache
                if (memCache[path]) {
                    urls[s.num.toString()] = memCache[path];
                    continue;
                }

                try {
                    const url = await getDownloadURL(ref(storage, path));
                    urls[s.num.toString()] = url;
                    memCache[path] = url; // zapisz do cache
                } catch (e) {
                    console.warn("Brak obrazka:", s.num, e);
                }
            }
            setImageUrls(urls);
        };
        loadImages();
    }, [bookNum, unitIndex, lessonIndex, story]);

    const handleSelectText = (textId: string) => {
        if (!selectedImage) return;
        if (selectedImage === textId) {
            setMatched((prev) => ({ ...prev, [textId]: true }));
        }
        setSelectedImage(null);
    };

    return (
        <div className="p-4">
            <h3
                className="text-lg font-bold mb-2 text-center"
                style={{ color: accentHex || "#333" }}
            >
                Match the Pictures and Words
            </h3>
            <p className="text-sm text-zinc-500 text-center mb-4">
                First select a picture, then choose the matching text.
            </p>


            {/* Obrazki */}
            <div className="flex flex-wrap justify-center gap-4 mb-6">
                {story.map((s) => {
                    const id = s.num.toString();
                    const isMatched = matched[id];
                    const isSelected = selectedImage === id;
                    return (
                        <button
                            key={id}
                            onClick={() => !isMatched && setSelectedImage(id)}
                            className={[
                                "rounded-xl overflow-hidden border-2 transition",
                                isMatched
                                    ? "border-green-500 opacity-80"
                                    : isSelected
                                        ? "border-blue-400"
                                        : "border-transparent",
                            ].join(" ")}
                        >
                            {imageUrls[id] ? (
                                <img
                                    src={imageUrls[id]}
                                    alt={s.text}
                                    className="w-40 h-28 object-contain bg-zinc-100"
                                />
                            ) : (
                                <div className="w-40 h-28 flex items-center justify-center bg-zinc-100 text-sm text-zinc-400">
                                    No image
                                </div>
                            )}
                        </button>
                    );
                })}
            </div>

            {/* Teksty */}
            <div className="flex flex-col gap-3">
                {texts.map((txt) => {
                    const isMatched = matched[txt.id];
                    return (
                        <button
                            key={txt.id}
                            onClick={() => !isMatched && handleSelectText(txt.id)}
                            className={[
                                "p-3 rounded-lg text-left transition",
                                isMatched
                                    ? "bg-green-500 text-white font-bold"
                                    : "bg-zinc-100 hover:bg-zinc-200",
                            ].join(" ")}
                        >
                            {txt.text}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MatchingExercise;
